import { Component, Input, OnInit, inject } from "@angular/core";
import { ControlConfigModel } from "@app/controls/models/ControlConfigModel";
import { BusinessNavigatorPermissionModel } from "@app/navigators/business-navigator/models/business-navigator-permission-model";
import { BusinessNavigatorRequestModel } from "@app/navigators/business-navigator/models/business-navigator-request-model";
import { BusinessNavigatorDataService } from "@app/navigators/business-navigator/services/business-navigator-data.service";
import { NavigatorConfigType } from "@app/navigators/enums/NavigatorConfigType";
import { NavGenericListFactory } from "@app/navigators/services/NavGenericListFactory";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";

@Component({
    selector: "business-controls",
    templateUrl: "./business-controls.component.html",
    standalone: false
})
export class BusinessControlsComponent implements OnInit {
    private _businessDs = inject(BusinessNavigatorDataService);
    private _navFactory = inject(NavGenericListFactory);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    @Input() requestModel: BusinessNavigatorRequestModel;
    @Input() permissionsModel: BusinessNavigatorPermissionModel;
    config: GenericListConfig;

    ngOnInit() {
        this.config = this._navFactory.createConfig(NavigatorConfigType.Control);

        this.config.dataMethod = () => this._businessDs.getControls(this.requestModel);
        this.config.hideRefreshButton = false;

        this.config.allowAdd = this.permissionsModel.canAddControl;
        this.config.addOverride = () => {
            const config = <ControlConfigModel>{
                organizationId: this.requestModel.organizationID,
                businessIds: [+this.requestModel.businessID],
            };
            this._tabService.generateTab(this._pages.Control, 0, "(C) New Control", config);
        };
    }
}
